const SUPER_MAX = 100;
const SUPER_PER_HIT = 6;
const SUPER_PER_KILL = 25;
const SUPER_PER_GRAZE = 4; // deliberately smaller than a hit (Classic's own graze was tuned below a direct hit's reward too) — a close-call bonus, not a substitute for actually fighting

export const SUPER_CONSTANTS = {
  max: SUPER_MAX,
  radius: 5,
  damage: 60,
  knockback: 6,
};

/**
 * Super v1 (S04, PLAN-CITY §5's "real super"): fills on hits/kills/grazes
 * (`combat/graze.ts` — Classic's ported near-miss mechanic, gotcha #30/#42),
 * a manual button consumes it for a radial blast around the player (see
 * combat/resolve.ts). `justCrossedReady()` mirrors Classic gotcha #30's
 * "every site that ADDS super needs the crossing cue" law — every gain path
 * (`onHit`/`onKill`/`onGraze`) routes through the single `add()` helper so
 * the cue can never be added to one source and silently missed on another.
 */
export class SuperMeter {
  value = 0;
  private wasReady = false;

  private add(amount: number): void {
    this.value = Math.min(SUPER_MAX, this.value + amount);
  }

  onHit(): void {
    this.add(SUPER_PER_HIT);
  }

  onKill(): void {
    this.add(SUPER_PER_KILL);
  }

  onGraze(): void {
    this.add(SUPER_PER_GRAZE);
  }

  get ready(): boolean {
    return this.value >= SUPER_MAX;
  }

  /** True exactly on the tick the meter crosses from not-ready to ready — the HUD reads this once to trigger a one-shot cue rather than re-triggering every frame `ready` stays true. */
  justCrossedReady(): boolean {
    const crossed = !this.wasReady && this.ready;
    this.wasReady = this.ready;
    return crossed;
  }

  /** Consumes the meter if ready; returns whether it fired. */
  consume(): boolean {
    if (!this.ready) return false;
    this.value = 0;
    this.wasReady = false;
    return true;
  }
}
